import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Divider, Form, Skeleton } from 'antd';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { StockTransferFormValues } from '@/core/domain/stock/Operations/Operations.types';
import StockTransferForm from '@/components/Movements/StockTransfer/StockTransferForm';
import { useRouteMatch } from 'react-router-dom';
import { useStockTransferDetail } from '@/core/domain/stock/Operations/Operations.hooks';
import { useEffect } from 'react';

export default function StockTransferDetailsPage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<StockTransferFormValues>();

  const { stockTransferId } = useRouteMatch().params as {
    stockTransferId: number;
  };

  const stockTransferData = useStockTransferDetail(stockTransferId);

  useEffect(() => {
    if (stockTransferData.data) {
      const data = stockTransferData.data.result;

      form.setFieldsValue({
        companyReceiveStockId: data.receiveCompany.companyId,
        companySendStockId: data.sendCompany.companyId,
        items: data.items.map((item) => ({
          ...item,
          description: item.itemName,
          quantity: item.oldQuantity - item.newQuantity,
        })),
      });
    }
  }, [stockTransferData.dataUpdatedAt]);

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <TabContentWrapper title={route.name}>
        <Skeleton loading={stockTransferData.isLoading}>
          <Form form={form}>
            <StockTransferForm isEdit />
          </Form>

          <Divider />

          <SpaceForButton>
            <ButtonBack path="/app/movements/stock-transfer" />
          </SpaceForButton>
        </Skeleton>
      </TabContentWrapper>
    </>
  );
}
